import { render } from "./ThanksPopup.vue?vue&type=template&id=3440bb2c"
import script from "./ThanksPopup.vue?vue&type=script&lang=js"
export * from "./ThanksPopup.vue?vue&type=script&lang=js"

import "./ThanksPopup.vue?vue&type=style&index=0&id=3440bb2c&lang=sass"

import exportComponent from "D:\\Programs\\OSPanel\\domains\\personal_form\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__